import { INIT_EDIT_QUOTE } from 'store/quotes/types';

import { types } from './actions';

const initialState = {
  componentId: null,
  customAttrs: [],
  isCustomAttrsModalOpen: false,
  isInitializing: false,
  isUpdatingCustomAttrs: false,
  partUuid: null,
};

const reducer = (state = initialState, action) => {
  const { payload } = action;
  switch (action.type) {
    case INIT_EDIT_QUOTE:
      return { ...initialState };
    case types.CUSTOM_ATTRS_MODAL_OPEN:
      return {
        ...state,
        componentId: payload.componentId,
        isCustomAttrsModalOpen: true,
        isInitializing: true,
        partUuid: payload.partUuid,
      };
    case types.CUSTOM_ATTRS_MODAL_INIT_FINISH:
      return {
        ...state,
        customAttrs: payload.customAttrs,
        isInitializing: false,
      };
    case types.CUSTOM_ATTRS_MODAL_CLOSE:
      return {
        ...state,
        componentId: null,
        customAttrs: [],
        isAddNewAttrModalOpen: false,
        isCustomAttrsModalOpen: false,
        partUuid: null,
      };
    case types.UPDATE_CUSTOM_ATTRS_REQUEST:
      return {
        ...state,
        isUpdatingCustomAttrs: true,
      };
    case types.UPDATE_CUSTOM_ATTRS_SUCCESS:
    case types.UPDATE_CUSTOM_ATTRS_ERROR:
      return {
        ...state,
        isUpdatingCustomAttrs: false,
      };
    default:
      return state;
  }
};

export default reducer;

const getScope = (state) => state.modules.quotes.customAttrsModal;

export const getComponentId = (state) => getScope(state).componentId;

export const getCustomAttrs = (state) => getScope(state).customAttrs;

export const getIsCustomAttrsModalOpen = (state) =>
  getScope(state).isCustomAttrsModalOpen;

export const getIsInitializing = (state) => getScope(state).isInitializing;

export const getIsUpdatingCustomAttrs = (state) =>
  getScope(state).isUpdatingCustomAttrs;

export const getPartUuid = (state) => getScope(state).partUuid;
